import { Component, OnInit, Input } from '@angular/core';
import { ProductService } from 'src/app/core/services/product.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css']
})
export class CategoryComponent implements OnInit {

  @Input()
  category:any;

  public productList: any[];
  public urlHost = "";
  public loading: boolean = true;
  constructor(
    private productService: ProductService,
    private router: ActivatedRoute
  ) {
    this.urlHost = environment.urlHostImage;
  }

  ngOnInit() {
    this.getProductList(this.category.codCategoria);
  }

  getProductList(codCategoria) {
    this.loading = true;
    this.productService.getProductList(codCategoria).subscribe(
      (data) => {
        this.productList = data;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  getValidate(product:any):boolean{
    return this.productService.getValidate(product);
  }

}
